let _base = ''
export function setIconBaseUrl(url: string) { _base = url.replace(/\/$/, '') }
function base(): string { return _base || 'http://127.0.0.1:8090' }
export function catIcon(id: number): string { return base() + '/static/icons/cat_' + id + '.png' }
export function stallIcon(id: number): string { return base() + '/static/icons/stall_' + id + '.png' }
export function prodIcon(id: number): string { return base() + '/static/icons/prod_' + id + '.png' }
export function uploadUrl(): string { return base() + '/api/upload' }
